'use client';
import { restartFlow } from '@/components/modal/cancelBody';
import { EmptyState } from '@repo/ui';
import { useDispatch } from 'react-redux';
import StepWrapper from './stepWrapper';

/**
 * Shown when the instance is on a step this version doesn't know, as in mobile: explain and offer a restart.
 */
export default function UnknownStep(): React.JSX.Element {
  const dispatch = useDispatch();
  return (
    <StepWrapper>
      <EmptyState
        icon="sync_problem"
        headingLevel="h1"
        title="No pudimos continuar con el registro"
        body="Actualizá la página o intentá más tarde."
        actionLabel="Empezar de nuevo"
        onAction={() => restartFlow(dispatch)}
      />
    </StepWrapper>
  );
}
